module.exports = __webpack_public_path__ + "static/img/bg_test2.f89d248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_test2.png
// module id = g9q/
// module chunks = 1